export const TourGuideHelper = {
  adjustScrolling,
  clickElement,
  scrollTop,
  returnCurrentTourState,
};
function adjustScrolling(
  elementName,
  scrollingElement,
  isDelay,
  toggleTouraguideaMethod
) {
  if (elementName && scrollingElement) {
    if (isDelay) {
      toggleTouraguideaMethod((prev) => ({
        ...prev,
        run: false,
      }));
    }
    const isElementInViewport = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    // If the element is not in the viewport, calculate scroll
    if (!isElementInViewport(elementName)) {
      const elementRect = elementName.getBoundingClientRect();
      const scrollerRect = scrollingElement.getBoundingClientRect();

      // Calculate how much to scroll to bring the element into the viewport
      const scrollLeft =
        scrollingElement.scrollLeft + (elementRect.left - scrollerRect.left);
      const scrollTop =
        scrollingElement.scrollTop + (elementRect.top - scrollerRect.top);

      // Scroll the virtual scroller to the element position smoothly
      scrollingElement.scrollTo({
        left: scrollLeft,
        behavior: "smooth", // Smooth scrolling effect
      });
      if (isDelay) {
        setTimeout(() => {
          toggleTouraguideaMethod((prev) => ({
            ...prev,
            run: true,
          }));
        }, 1000);
      }
    } else if (isDelay) {
      toggleTouraguideaMethod((prev) => ({
        ...prev,
        run: true,
      }));
    }
  }
}

function clickElement(elementName, toggleTouraguideaMethod) {
  const button = document.querySelector(elementName);
  if (button) {
    button.click();
    const observer = new MutationObserver((mutationsList, observer) => {
      const menu = document.querySelector(".MuiDataGrid-menu");
      if (menu) {
        // Stop observing once the menu is found
        observer.disconnect();

        // Trigger the toggleTouraguideaMethod after the menu is rendered
        toggleTouraguideaMethod((prev) => ({
          ...prev,
          run: true,
        }));
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
  // setTimeout(() => {
  //   toggleTouraguideaMethod((prev) => ({
  //     ...prev,
  //     run: true,
  //   }));
  // }, 1000);
}

function scrollTop(elementName, scrollElement) {
  const elementRect = elementName.getBoundingClientRect();
  const scrollerRect = scrollElement.getBoundingClientRect();

  const scrollTop =
    scrollElement.scrollTop + (elementRect.top - scrollerRect.top);

  scrollElement.scrollTo({
    top: scrollTop,
    behavior: "smooth",
  });
}

function returnCurrentTourState(
  tourGuidSaveSetting,
  setTourGuidSaveSetting,
  title
) {
  let tourStatus = [];
  if (tourGuidSaveSetting.length > 0) {
    tourStatus = tourGuidSaveSetting.filter(
      (item) =>
        item.title.toLowerCase() === title.toLowerCase() && item.isTourActive
    );
  } else {
    tourStatus = JSON.parse(sessionStorage.getItem("onBoardStoryGuid")).filter(
      (item) =>
        item.title.toLowerCase() === title.toLowerCase() && item.isTourActive
    );
    setTourGuidSaveSetting(
      JSON.parse(sessionStorage.getItem("onBoardStoryGuid"))
    );
  }
  return tourStatus;
}
